import { translateText, translateTree } from "@/i18n/translate";
import { useLang } from "@/i18n/LangContext";

const MEMBERSHIP_EN = {
  Einzelpersonen: "Individuals",
  Startups: "Start-ups",
  Spender: "Donors",
  Unternehmen: "Companies",
  "Kantone, Banken und öffentliche Institutionen": "Cantons, banks and public institutions",
};
export const MEMBERSHIP_VALUES = Object.keys(MEMBERSHIP_EN);

const P = {
  de: {
    area: "Kundenbereich",
    admin: "Administration",
    backToSite: "Zur Website",
    logout: "Abmelden",
    loading: "Wird geladen …",
    nav: { overview: "Übersicht", profile: "Profil", tickets: "Anfragen", clients: "Kunden", contacts: "Website-Anfragen" },
    unread: (n) => (n === 1 ? "1 neue Antwort" : `${n} neue Antworten`),
    unreadMsg: (n) => (n === 1 ? "1 neue Nachricht" : `${n} neue Nachrichten`),
    menu: "Menü öffnen",
    force: {
      title: "Bitte legen Sie ein neues Passwort fest.",
      text: "Sie haben sich mit einem temporären Passwort angemeldet. Wählen Sie jetzt ein eigenes Passwort, um fortzufahren.",
      current: "Temporäres Passwort",
      submit: "Passwort speichern",
    },
    temp: {
      button: "Temporäres Passwort",
      confirmTitle: "Temporäres Passwort erstellen?",
      confirmText: (name) => `Das bisherige Passwort von ${name} wird sofort ungültig. Beim nächsten Login muss ein neues Passwort gewählt werden.`,
      confirm: "Erstellen",
      cancel: "Abbrechen",
      resultTitle: "Temporäres Passwort",
      resultText: "Teilen Sie dieses Passwort dem Kunden auf sicherem Weg mit (z. B. telefonisch). Es wird nur jetzt angezeigt.",
      copy: "Kopieren",
      copied: "Kopiert",
      close: "Schliessen",
    },
    auth: {
      loginTitle: "Anmelden",
      loginIntro: "Melden Sie sich mit Ihrer E-Mail-Adresse und Ihrem Passwort an.",
      registerTitle: "Konto erstellen",
      registerIntro: "Nach der Registrierung können Sie Ihren Kundenbereich sofort nutzen.",
      side: "Ein geschützter Bereich für Anfragen, Dokumente und den direkten Austausch mit unserem Team.",
      email: "E-Mail",
      password: "Passwort",
      passwordHint: "Mindestens 8 Zeichen",
      password2: "Passwort wiederholen",
      name: "Name",
      org: "Organisation",
      phone: "Telefon",
      optional: "optional",
      consentA: "Ich habe die ",
      consentLink: "Datenschutzerklärung",
      consentB: " gelesen und bin einverstanden.",
      submitLogin: "Anmelden",
      submitRegister: "Konto erstellen",
      noAccount: "Noch kein Konto?",
      toRegister: "Jetzt registrieren",
      hasAccount: "Bereits registriert?",
      toLogin: "Zur Anmeldung",
      err: {
        email: "Bitte geben Sie eine gültige E-Mail-Adresse an.",
        password: "Das Passwort muss mindestens 8 Zeichen lang sein.",
        passwordEmpty: "Bitte geben Sie Ihr Passwort ein.",
        password2: "Die Passwörter stimmen nicht überein.",
        name: "Bitte geben Sie Ihren Namen an (mindestens 2 Zeichen).",
        consent: "Bitte bestätigen Sie die Datenschutzerklärung.",
      },
    },
    status: {
      pendingTitle: "Ihr Konto wird geprüft.",
      pendingText: "Vielen Dank für Ihre Registrierung. Unser Team prüft Ihre Angaben und schaltet den Zugang frei. Bitte melden Sie sich später erneut an.",
      rejectedTitle: "Ihr Konto ist gesperrt.",
      rejectedText: "Für Rückfragen kontaktieren Sie uns bitte per E-Mail oder Telefon.",
      check: "Status erneut prüfen",
    },
    ticket: {
      neu: "Neu",
      in_bearbeitung: "In Bearbeitung",
      wartet_auf_kunde: "Rückmeldung erforderlich",
      abgeschlossen: "Abgeschlossen",
    },
    userStatus: { pending: "Freigabe ausstehend", approved: "Aktiv", rejected: "Gesperrt" },
    categories: { Leistungen: "Leistungen", Mitgliedschaft: "Mitgliedschaft", Kundenbereich: "Kundenbereich", Sonstiges: "Sonstiges" },
    dash: {
      hello: "Guten Tag",
      intro: "Hier verwalten Sie Ihre Anfragen und tauschen sich direkt mit unserem Team aus.",
      newTicket: "Neue Anfrage",
      myTickets: "Meine Anfragen",
      empty: "Sie haben noch keine Anfragen gestellt.",
      emptyCta: "Erste Anfrage erstellen",
      membership: "Mitgliedschaft",
      noMembership: "Keine Mitgliedschaft hinterlegt.",
      membershipHint: "Mitgliedsbeiträge sind Jahresbeiträge an den Verein und unabhängig von Leistungen.",
      membershipAsk: "Mitgliedschaft anfragen",
      open: "Offen",
      closed: "Abgeschlossen",
      newReply: "Neue Antwort",
      newMessage: "Neue Nachricht",
      updated: "Aktualisiert",
      ref: "Ref.",
    },
    newT: {
      title: "Neue Anfrage",
      intro: "Beschreiben Sie Ihre Aufgabe. Dokumente können Sie direkt anhängen.",
      subject: "Betreff",
      category: "Thema",
      message: "Beschreibung",
      placeholder: "Ausgangslage, betroffene Systeme, gewünschtes Ergebnis …",
      submit: "Anfrage senden",
      cancel: "Abbrechen",
      err: {
        subject: "Bitte geben Sie einen Betreff an (mindestens 3 Zeichen).",
        message: "Bitte beschreiben Sie Ihre Anfrage in mindestens 10 Zeichen.",
      },
    },
    thread: {
      back: "Zurück zur Übersicht",
      conversation: "Verlauf",
      staff: "Swiss Blockchain Alliance",
      you: "Sie",
      client: "Kunde",
      reply: "Antwort schreiben",
      placeholder: "Ihre Nachricht …",
      send: "Senden",
      sending: "Wird gesendet …",
      attach: "Dateien anhängen",
      fileRules: "PDF, Bilder, DOCX, XLSX, TXT, CSV · max. 10 MB je Datei · max. 5 Dateien",
      remove: "entfernen",
      download: "Herunterladen",
      emptyMsg: "Bitte schreiben Sie eine Nachricht oder hängen Sie eine Datei an.",
      closedNote: "Diese Anfrage ist abgeschlossen. Mit einer neuen Nachricht wird sie wieder geöffnet.",
      status: "Status",
      category: "Thema",
      created: "Erstellt",
    },
    profile: {
      title: "Profil",
      data: "Persönliche Angaben",
      save: "Speichern",
      saved: "Gespeichert.",
      pw: "Passwort ändern",
      current: "Aktuelles Passwort",
      newPw: "Neues Passwort",
      pwSave: "Passwort ändern",
      pwSaved: "Passwort geändert.",
      account: "Konto",
      since: "Registriert seit",
    },
    adm: {
      overview: "Übersicht",
      pending: "Freigaben ausstehend",
      clients: "Freigegebene Kunden",
      open: "Offene Anfragen",
      unread: "Ungelesene Anfragen",
      contacts: "Website-Anfragen",
      approve: "Entsperren",
      reject: "Sperren",
      reset: "Zurücksetzen",
      noPending: "Keine offenen Freigaben.",
      latest: "Aktuelle Anfragen",
      all: "Alle",
      openF: "Offen",
      noTickets: "Keine Anfragen gefunden.",
      noClients: "Keine Kunden gefunden.",
      registered: "Registriert",
      membership: "Mitgliedschaft",
      none: "Keine",
      ticketsOf: "Anfragen anzeigen",
      clientInfo: "Kunde",
      changeStatus: "Status ändern",
      reply: "Antworten per E-Mail",
      done: "Erledigt",
      markDone: "Als erledigt markieren",
      markOpen: "Wieder öffnen",
      noContacts: "Keine Website-Anfragen vorhanden.",
      filterClient: "Gefiltert nach Kunde",
      clearFilter: "Filter entfernen",
      updated: "Gespeichert.",
      search: "Anfragen durchsuchen",
      searchPh: "Betreff, Kunde, Organisation oder Ref.-Nr.",
      clearSearch: "Suche leeren",
      results: (n) => (n === 1 ? "1 Treffer" : `${n} Treffer`),
      noResults: (q) => `Keine Anfragen gefunden für «${q}».`,
      searchClients: "Kunden durchsuchen",
      searchClientsPh: "Name, E-Mail oder Organisation",
      noClientResults: (q) => `Keine Kunden gefunden für «${q}».`,
      notes: "Interne Notizen",
      notesHint: "Nur für Mitarbeitende sichtbar. Kunden sehen diese Notizen nicht.",
      notePh: "Notiz hinzufügen …",
      addNote: "Notiz speichern",
      noNotes: "Noch keine Notizen.",
      deleteNote: "Notiz löschen",
      confirmDelete: "Wirklich löschen?",
      emptyNote: "Bitte geben Sie einen Text ein.",
    },
    err: {
      email_taken: "Diese E-Mail-Adresse ist bereits registriert.",
      invalid_credentials: "E-Mail oder Passwort ist falsch.",
      locked: "Zu viele Fehlversuche. Bitte versuchen Sie es in 15 Minuten erneut.",
      wrong_password: "Das aktuelle Passwort ist falsch.",
      file_type: "Dieser Dateityp ist nicht erlaubt.",
      file_size: "Eine Datei ist grösser als 10 MB.",
      file_empty: "Eine Datei ist leer.",
      too_many_files: "Maximal 5 Dateien pro Nachricht.",
      empty_message: "Bitte schreiben Sie eine Nachricht oder hängen Sie eine Datei an.",
      network: "Keine Verbindung zum Server. Bitte versuchen Sie es erneut.",
      generic: "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    },
  },
  en: {
    area: "Client area",
    admin: "Administration",
    backToSite: "Back to website",
    logout: "Sign out",
    loading: "Loading …",
    nav: { overview: "Overview", profile: "Profile", tickets: "Requests", clients: "Clients", contacts: "Website enquiries" },
    unread: (n) => (n === 1 ? "1 new reply" : `${n} new replies`),
    unreadMsg: (n) => (n === 1 ? "1 new message" : `${n} new messages`),
    menu: "Open menu",
    force: {
      title: "Please set a new password.",
      text: "You signed in with a temporary password. Choose your own password now to continue.",
      current: "Temporary password",
      submit: "Save password",
    },
    temp: {
      button: "Temporary password",
      confirmTitle: "Create a temporary password?",
      confirmText: (name) => `The current password of ${name} becomes invalid immediately. A new password must be chosen at the next sign-in.`,
      confirm: "Create",
      cancel: "Cancel",
      resultTitle: "Temporary password",
      resultText: "Share this password with the client through a secure channel (e.g. by phone). It is shown only now.",
      copy: "Copy",
      copied: "Copied",
      close: "Close",
    },
    auth: {
      loginTitle: "Sign in",
      loginIntro: "Sign in with your email address and password.",
      registerTitle: "Create account",
      registerIntro: "Your client area is available immediately after registration.",
      side: "A protected area for requests, documents and direct exchange with our team.",
      email: "Email",
      password: "Password",
      passwordHint: "At least 8 characters",
      password2: "Repeat password",
      name: "Name",
      org: "Organisation",
      phone: "Phone",
      optional: "optional",
      consentA: "I have read and agree to the ",
      consentLink: "privacy policy",
      consentB: ".",
      submitLogin: "Sign in",
      submitRegister: "Create account",
      noAccount: "No account yet?",
      toRegister: "Register now",
      hasAccount: "Already registered?",
      toLogin: "Sign in",
      err: {
        email: "Please enter a valid email address.",
        password: "The password must be at least 8 characters long.",
        passwordEmpty: "Please enter your password.",
        password2: "The passwords do not match.",
        name: "Please enter your name (at least 2 characters).",
        consent: "Please confirm the privacy policy.",
      },
    },
    status: {
      pendingTitle: "Your account is being reviewed.",
      pendingText: "Thank you for registering. Our team is reviewing your details and will activate your access. Please sign in again later.",
      rejectedTitle: "Your account is blocked.",
      rejectedText: "If you have any questions, please contact us by email or phone.",
      check: "Check status again",
    },
    ticket: {
      neu: "New",
      in_bearbeitung: "In progress",
      wartet_auf_kunde: "Reply needed",
      abgeschlossen: "Closed",
    },
    userStatus: { pending: "Pending approval", approved: "Active", rejected: "Blocked" },
    categories: { Leistungen: "Services", Mitgliedschaft: "Membership", Kundenbereich: "Client area", Sonstiges: "Other" },
    dash: {
      hello: "Hello",
      intro: "Manage your requests here and communicate directly with our team.",
      newTicket: "New request",
      myTickets: "My requests",
      empty: "You have not submitted any requests yet.",
      emptyCta: "Create first request",
      membership: "Membership",
      noMembership: "No membership on file.",
      membershipHint: "Membership fees are annual contributions to the association and independent of services.",
      membershipAsk: "Request membership",
      open: "Open",
      closed: "Closed",
      newReply: "New reply",
      newMessage: "New message",
      updated: "Updated",
      ref: "Ref.",
    },
    newT: {
      title: "New request",
      intro: "Describe your task. You can attach documents directly.",
      subject: "Subject",
      category: "Topic",
      message: "Description",
      placeholder: "Situation, affected systems, desired outcome …",
      submit: "Send request",
      cancel: "Cancel",
      err: {
        subject: "Please enter a subject (at least 3 characters).",
        message: "Please describe your request in at least 10 characters.",
      },
    },
    thread: {
      back: "Back to overview",
      conversation: "Conversation",
      staff: "Swiss Blockchain Alliance",
      you: "You",
      client: "Client",
      reply: "Write a reply",
      placeholder: "Your message …",
      send: "Send",
      sending: "Sending …",
      attach: "Attach files",
      fileRules: "PDF, images, DOCX, XLSX, TXT, CSV · max. 10 MB per file · max. 5 files",
      remove: "remove",
      download: "Download",
      emptyMsg: "Please write a message or attach a file.",
      closedNote: "This request is closed. Sending a new message will reopen it.",
      status: "Status",
      category: "Topic",
      created: "Created",
    },
    profile: {
      title: "Profile",
      data: "Personal details",
      save: "Save",
      saved: "Saved.",
      pw: "Change password",
      current: "Current password",
      newPw: "New password",
      pwSave: "Change password",
      pwSaved: "Password changed.",
      account: "Account",
      since: "Registered since",
    },
    adm: {
      overview: "Overview",
      pending: "Pending approvals",
      clients: "Approved clients",
      open: "Open requests",
      unread: "Unread requests",
      contacts: "Website enquiries",
      approve: "Unblock",
      reject: "Block",
      reset: "Reset",
      noPending: "No pending approvals.",
      latest: "Latest requests",
      all: "All",
      openF: "Open",
      noTickets: "No requests found.",
      noClients: "No clients found.",
      registered: "Registered",
      membership: "Membership",
      none: "None",
      ticketsOf: "Show requests",
      clientInfo: "Client",
      changeStatus: "Change status",
      reply: "Reply by email",
      done: "Done",
      markDone: "Mark as done",
      markOpen: "Reopen",
      noContacts: "No website enquiries yet.",
      filterClient: "Filtered by client",
      clearFilter: "Clear filter",
      updated: "Saved.",
      search: "Search requests",
      searchPh: "Subject, client, organisation or ref. no.",
      clearSearch: "Clear search",
      results: (n) => (n === 1 ? "1 result" : `${n} results`),
      noResults: (q) => `No requests found for «${q}».`,
      searchClients: "Search clients",
      searchClientsPh: "Name, email or organisation",
      noClientResults: (q) => `No clients found for «${q}».`,
      notes: "Internal notes",
      notesHint: "Visible to staff only. Clients never see these notes.",
      notePh: "Add a note …",
      addNote: "Save note",
      noNotes: "No notes yet.",
      deleteNote: "Delete note",
      confirmDelete: "Really delete?",
      emptyNote: "Please enter some text.",
    },
    err: {
      email_taken: "This email address is already registered.",
      invalid_credentials: "Email or password is incorrect.",
      locked: "Too many failed attempts. Please try again in 15 minutes.",
      wrong_password: "The current password is incorrect.",
      file_type: "This file type is not allowed.",
      file_size: "A file is larger than 10 MB.",
      file_empty: "A file is empty.",
      too_many_files: "Maximum 5 files per message.",
      empty_message: "Please write a message or attach a file.",
      network: "No connection to the server. Please try again.",
      generic: "An error occurred. Please try again.",
    },
  },
};

export const usePortal = () => {
  const { lang } = useLang();
  const p = translateTree(P[lang] || P.en, lang);
  const fmtDate = (iso) =>
    iso ? new Intl.DateTimeFormat(({en:"en-GB",de:"de-CH",sv:"sv-SE",da:"da-DK",fr:"fr-CH",nl:"nl-NL",no:"nb-NO"})[lang], { dateStyle: "medium", timeStyle: "short" }).format(new Date(iso)) : "";
  const membershipLabel = (v) => (v ? (lang !== "de" ? translateText(MEMBERSHIP_EN[v] || v, lang) : v) : p.adm.none);
  const errText = (code) => p.err[code] || p.err.generic;
  return { p, lang, fmtDate, membershipLabel, errText };
};
